function MenuAula8() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#Google-Mobile">Google Mobile</a></li>
              <li><a href="#Google-pages-Speed-Tools">Google pages Speed Tools</a></li>
              <li><a href="#Conclusão">Conclusão</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula8;